export default __webpack_public_path__ + "static/media/fitnesssidemenu.7fb51b1b.png";